// This file is generated by pnpm icons:generate. Do not edit.

import {createSVG} from '../TEMPLATE'

export const VerifierCheck = createSVG({
  elements: [
    {
      fill: 'currentColor',
      stroke: 'none',
      type: 'path',
      d: 'M21.174 9.64c-.353-.37-.719-.75-.856-1.085-.128-.307-.135-.815-.143-1.307-.014-.915-.03-1.952-.75-2.673s-1.758-.736-2.673-.75c-.492-.007-1-.015-1.307-.143-.333-.137-.715-.503-1.084-.856C13.714 2.204 12.979 1.5 12 1.5s-1.713.704-2.36 1.326c-.37.353-.75.719-1.085.857-.305.127-.815.135-1.307.142-.915.014-1.952.03-2.673.75s-.731 1.758-.75 2.673c-.008.492-.015 1-.143 1.307-.137.333-.503.715-.856 1.084C2.204 10.286 1.5 11.021 1.5 12s.704 1.713 1.326 2.36c.353.37.719.75.857 1.085.127.307.135.815.142 1.307.014.915.03 1.952.75 2.673s1.758.736 2.673.75c.492.007 1 .015 1.307.142.333.138.715.504 1.084.857.647.622 1.382 1.326 2.361 1.326s1.713-.704 2.36-1.326c.37-.353.75-.719 1.085-.856.307-.128.815-.135 1.307-.143.915-.014 1.952-.03 2.673-.75s.736-1.758.75-2.673c.007-.492.015-1 .142-1.307.138-.333.504-.715.857-1.084.622-.647 1.326-1.382 1.326-2.361s-.704-1.713-1.326-2.36Zm-4.893.64-5.25 5.25a.75.75 0 0 1-1.062 0l-2.25-2.25a.75.75 0 0 1 1.062-1.06l1.719 1.72 4.72-4.72a.75.75 0 0 1 1.06 1.06Z',
      fillRule: 'evenodd',
    },
  ],
  viewBox: '0 0 24 24',
  glyph: 'VerifierCheck',
})
